<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="新建基因检测套餐"></pt-page-title>
    <detection-package-form v-model="detectionPackageForm" ref="child"></detection-package-form>
    <div class="marginTop">
    <el-button type="primary" @click="certain">新建</el-button>
    <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
// 组件class前缀
import detectionPackageForm from 'cps/gene-product/detection-package-form'
const prefixCls = 'pt-detection-package-new'

export default {
  name: 'pt-detection-package-new',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    detectionPackageForm
  },
  data () {
    return {
      detectionPackageForm: {},
      loading: false
    }
  },
  methods: {
    cancel () {
      history.go(-1)
    },
    changFormat (fullObj) {
      if (fullObj.items) {
        fullObj.items.forEach((element, index) => {
          if (element.type === 'DETECTION') {
            let obj = {
              bindCorpusId: element.bindCorpusId,
              type: element.type,
              detectionItemId: element.id || element.detectionItemId
            }
            let allConfig = ['detectionItemConfigId_RISK', 'detectionItemConfigId_CAUSAL', 'detectionItemConfigId_CAUSAL_AUTO']
            let detectionItemConfigIds = []
            allConfig.forEach(e => {
              if (element[e]) {
                detectionItemConfigIds.push(element[e])
              }
            })
            obj.detectionItemConfigIds = detectionItemConfigIds
            fullObj.items[index] = obj
          } else {
            this.changFormat(element)
          }
        })
      }
    },
    certain () {
      this.$refs.child.formValidate().then(async () => {
        // console.log(this.detectionPackageForm)
        // 处理检测项数据为需要的JSON数据
        // console.log('this.detectionPackageForm', JSON.parse(JSON.stringify(this.detectionPackageForm)))
        this.changFormat(this.detectionPackageForm)
        if (this.detectionPackageForm.reportParameters.splitBooks === false) {
          this.detectionPackageForm.reportParameters.bookSplittingParameters = {
            'book0StartChapter': '',
            'book1StartChapter': ''
          }
        }
        let copyData = JSON.parse(JSON.stringify(this.detectionPackageForm))
        if (copyData.packageType === 'OTHER') {
          copyData.packageType = 'CUSTOMER'
        }
        this.loading = true
        try {
          let primary = await this.$store.dispatch('getPrimaryOrganization')
          copyData.agentId = primary.tenantId
          this.$store.dispatch('detectionPackageAdd', copyData).then((response) => {
            this.$message.success('新建成功!')
            // 重置表单
            // this.$refs.child.reset()
            this.loading = false
            history.go(-1)
          }).catch((error) => {
            this.loading = false
            console.error(error)
            this.$message.error(error)
          })
        } catch (err) {
          this.loading = false
          this.$message.error(err)
        }
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
